const sublinks = [
    {
        id: 1,
        title: 'Education',
        head: [
            { head1: "MES  mannarkad", subhead1: 'BACHLORS OF COMPUTER SCIECE', date: [{ date1: "2021-2024" }] },
            { head1: "GVHSS MKBA", subhead1: 'BIOLOGY SCIENCE', date: [{ date1: "2019-2021" }] },
            { head1: "GVHSS MKBA", subhead1: 'STATE', date: [{ date1: "2015-2019" }] },


        ]


    },
    {
        id: 2,
        title: 'work History',
        head: [
            { head1: "student at mes kc", subhead1: 'still ongoing bachlors degree', date: [{ date1: "2021-2024" }], },
        ]
    },
    {
        id: 3,
        title: 'programmng Skills',
        head: [
            {language:'Html',percent:'90',},
            {language:'react js',percent:'60',},
            {language:'css',percent:'75',},
            {language:'node js',percent:'5',},
            {language:'javascript',percent:'50',},
        ]
    },
    {
        id: 4,
        title: 'projects',
        head: [
            { head1: "personal website", subhead1:<a href="https://github.com/Hishammpsnhn/personal-portfolio" >Git source code click here..</a>, date: [{ date1: "2022" }], },
            { head1: "Tesla clone", subhead1:<a href="https://tesla-clone-hisham.netlify.app/" >click here..</a>, date: [{ date1: "2022" }], },
        ]
    },
    {
        id: 5,
        title: 'Intrests',
        head: [
            { head1: "Music", subhead1: 'lisening music ', date: [], },
            { head1: "compititive gaminig", subhead1: 'online game like pubg  etc..', date: [], },
        ]
    },
];
export default sublinks